import {
  AccreditationStatus,
  AccreditationDateFields,
} from '../../shared-types'

export type NewYorkPendingAccreditation = {
  id: string
  status: AccreditationStatus
  topicArea: string | null
  expirationDate: string | null
  notes: string | null
  createdTime: string
  updatedTime: string
} & AccreditationDateFields

export type NewYorkFinalizedAccreditation = {
  id: string
  topicArea: string
  expirationDate: string | null
  createdTime: string
  updatedTime: string
}

export let newYorkTopicAreas = [
  'Preparatory',
  'Airway',
  'Pharmacology | Med Admin | Emergency Meds',
  'Immunology',
  'Toxicology',
  'Endocrine',
  'Neurology',
  'Abdominal | Geni-Renal | GI | Hematology',
  'Respiratory',
  'Psychiatric',
  'Cardiology',
  'Shock and Resuscitation',
  'Trauma',
  'Geriatrics',
  'OB | Neonate | Pediatrics',
  'Special Needs Pt',
  'EMS Operations',
  'Mental Health of EMT',
  'Patient Lifting and Moving',
  'Pediatric Safe Transport',
  'Emergency Vehicle Driver Training',
]
